import { Box, Typography, Button } from '@mui/material';
import ComputerIcon from '@mui/icons-material/Computer';

export default function GateStep({ onRetry, onCancel }) {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  return (
    <Box sx={{ textAlign: 'center', maxWidth: 420, mx: 'auto', py: 4 }}>
      <ComputerIcon sx={{ fontSize: 56, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h6" gutterBottom>Open this on a computer</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Updating your sensor needs <strong>Chrome or Edge on a desktop or laptop</strong>. Phones and other
        browsers can&apos;t connect to the sensor over USB.
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, wordBreak: 'break-all' }}>{url}</Typography>
      <Button variant="outlined" onClick={() => navigator.clipboard?.writeText(url)}>Copy link</Button>
      {onRetry && <Button sx={{ ml: 1 }} onClick={onRetry}>Try again</Button>}
      {onCancel && <Button sx={{ ml: 1 }} variant="outlined" onClick={onCancel}>Close</Button>}
    </Box>
  );
}
